import type { WorkspacePort } from '@crowdex/workspace-protocol';
import { useEffect, useState } from 'react';
import type { WorkspaceClient } from '@/lib/workspaces/workspace-client';

const POLL_MS = 3_000;

/**
 * The ports the processes of a local workspace listen on (a dev server), polled while the Ports
 * tab shows (D38): on this computer they open at `localhost` as they are, nothing to forward.
 */
export function useLocalPorts(
  client: WorkspaceClient | null,
  active: boolean,
): readonly WorkspacePort[] {
  const [ports, setPorts] = useState<readonly WorkspacePort[]>([]);
  useEffect(() => {
    if (client === null || !active) return;
    let disposed = false;
    let timer: ReturnType<typeof setTimeout> | undefined;
    const poll = async () => {
      const listed = await client.listPorts().catch(() => null);
      if (disposed) return;
      if (listed !== null)
        setPorts((current) =>
          JSON.stringify(current) === JSON.stringify(listed) ? current : listed,
        );
      timer = setTimeout(() => void poll(), POLL_MS);
    };
    void poll();
    return () => {
      disposed = true;
      clearTimeout(timer);
    };
  }, [active, client]);
  return client === null ? [] : ports;
}
